import Swiper from "swiper/bundle"

let mySwiper = new Swiper(".mySwiper", {
    speed: 2000,
    loop: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 4000,
        waitForTransition: true,
    },
});

let aboutSwiper = new Swiper(".AboutSwiper", {
    speed: 800,
    loop: true,
    autoplay: {
        delay: 3000,
        waitForTransition: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

let stayFullSwiperS = new Swiper(".stayFullSwiperS", {
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

let staySwiperS = new Swiper(".staySwiperS", {
    slidesPerView: "auto",
    loop: true,
    centeredSlides: true,
    autoplay: {
        delay: 5000,
        waitForTransition: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// window.cswiper = (i) => {
//     stayFullSwiperS.slideTo(i, 0)
// }

let staySwiperN = new Swiper(".staySwiperN", {
    slidesPerView: "auto",
    loop: true,
    centeredSlides: true,
    autoplay: {
        delay: 5000,
        waitForTransition: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

let stayFullSwiperN = new Swiper(".stayFullSwiperN", {
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

if (window.innerWidth > 1024) {
    var slides = document.querySelectorAll(".staySwiperS .swiper-slide")
    slides.forEach((slide) => {
        slide.addEventListener("click", () => {
            if (slide.classList.contains("swiper-slide-active")) {
                document.querySelector(".buil__innerFullS").classList.add("is-on")
                stayFullSwiperS.slideTo(staySwiperS.realIndex + 1, 0)
            }
        })
    })

    var slides = document.querySelectorAll(".staySwiperN .swiper-slide")
    slides.forEach((slide) => {
        slide.addEventListener("click", () => {
            if (slide.classList.contains("swiper-slide-active")) {
                document.querySelector(".buil__innerFullN").classList.add("is-on")
                stayFullSwiperN.slideTo(staySwiperN.realIndex + 1, 0)
            }
        })
    })
}

{
    /* <div class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <figure>
                    <img src="" alt="" />
                </figure>
            </div>
        </div>
    </div> */

    // @import '../../node_modules/swiper/swiper-bundle.min.css';

}